<template>
  <div class="page">
    <a-table
      class="sec"
      size="small"
      :rowKey="(record) => record.id"
      bordered
      :columns="columns"
      :data-source="list"
      :pagination="false"
    >
      <template slot="time" slot-scope="text, record">
        {{ record.start_at }}
        -
        {{ record.end_at }}
      </template>
      
      <template slot="status" slot-scope="text, record">
        <a-tag :color="record.status_color">{{ record.status }}</a-tag>
      </template>

      <template slot="action" slot-scope="text, record">
        <router-link :to="'/exh/info?id='+record.id">详情</router-link>
        <a-divider type="vertical" />
        <router-link :to="'/schedule/list?exh_id='+record.id">日程</router-link>
        <a-divider type="vertical" />
        <router-link :to="'/notice/list?exh_id='+record.id">公告</router-link>
        <a-divider type="vertical" />
        <router-link :to="'/activity/list?exh_id='+record.id">活动</router-link>
        <a-divider type="vertical" />
        <router-link :to="'/exh/seller?exh_id='+record.id">贝商</router-link>
        <a-divider type="vertical" />
        <router-link :to="'/exhMenpiao/list?exh_id='+record.id">门票</router-link>
        <a-divider type="vertical" />
        <router-link :to="'/exhMenpiao/menpiaoTongji?exh_id='+record.id">门票统计</router-link>
        <a-divider type="vertical" />
        <router-link :to="'/exh/update?id='+record.id">编辑</router-link>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            状态 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-for="(status, index) in statusList" :key="index" @click="updateStatus(record.id, status)">{{status}}</a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </a-table>

    <a-pagination
      class="pagination"
      showQuickJumper
      v-model="page.now_page"
      :defaultPageSize="page.page_size"
      :total="page.amount"
      @change="changePage"
    />
  </div>
</template>

<style lang='scss' scoped>
</style>

<script>
const columns = [
  {
    title: "#",
    dataIndex: "id",
  },
  {
    title: "贝展",
    dataIndex: "title",
  },
  {
    title: "场地",
    dataIndex: "place",
  },
  {
    title: "主办方",
    dataIndex: "zhuban",
  },
  {
    title: "贝展时间",
    scopedSlots: {
      customRender: "time",
    },
  },
  {
    title: "报名时间",
    scopedSlots: {
      customRender: "join_time",
    },
  },
  {
    title: "状态",
    scopedSlots: {
      customRender: "status",
    },
  },
  {
    title: "操作",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export default {
  data() {
    return {
      columns,
      list: [],
      statusList: ['未显示', '筹备中', '进行中', '已完成', '已删除'],
      page: {
        now_page: 1,
        page_size: 50,
        amount: 0,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changePage(e) {
      this.page.now_page = e;
      this.getList();
    },

    async getList() {
      const page = this.page.now_page;
      const r = await this.$axios.get("/exh/getList", {
        params: {
          page,
        },
      });

      if (r.status != 1) return;

      this.list = r.list;
      this.page.amount = r.amount;
    },

    async updateStatus (id, status) {
      const r = await this.$axios.post('/exh/updateStatus', {
        id,
        status
      })

      if(r.status == 1) this.getList()
    }
  },
};
</script>